<div *ngIf="languaje === 'en'">
	<li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
		<a class="icon-Combined-Shape-4">Privacy Notice</a>
	</li>
	
	<a class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Privacy Notice</a>
	<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
	

    <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">PRIVACY NOTICE </h2>
	
		<div class="container" [ngClass]="{'show': show_description1}">
      <p>The <strong>CIBC Caribbean My Rewards</strong> program (including <strong>Fly Care/Stay Care</strong> Experiences) is available and accessible to several entities including brand franchises, merchants, and financial institutions, among others.</p>
      <p>To access your <strong>Privacy Notice </strong>information, you must visit your Bank's Website directly.</p>
		</div>
  
	</div>
</div>




<!--Español-->
<!--Español-->


<div *ngIf="languaje === 'es'">
  <li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
    <a class="icon-Combined-Shape-4">Aviso de Privacidad</a>
  </li>
  
  <a class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Aviso de Privacidad</a>
  <div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
  
    <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">AVISO DE PRIVACIDAD </h2>
  
    <div class="container" [ngClass]="{'show': show_description1}">
    	<p>El programa de <strong>CIBC FirstCaribbean</strong> (incluidas las Experiencias <strong>Fly Care</strong>/<strong>Stay Care</strong>), est&aacute;n disponibles y pueden ser utilizados por m&uacute;ltiples entidades incluyendo Franquicias, Comercios y Clientes Financieros, entre otros. Por lo tanto, para acceder a la informaci&oacute;n de su <strong>Aviso de Privacidad</strong> debe visitar el Sitio Web de su Banco directamente.</p>
    </div>

  </div>
</div>
